import { Tween24, Ease24 } from 'tween24'

const opener = document.querySelector('.nav-opener')
const closer = document.querySelector('.nav-closer')
const spnav = document.querySelector('.sp-nav')

export default function () {
  opener.addEventListener('click', (event) => {
    event.preventDefault()
    spnav.style.display = "flex"
    Tween24.serial(
      Tween24.prop(spnav).opacity(0),
      Tween24.tween(spnav, .3, Ease24._1_SineInOut).opacity(1)
    ).onComplete(()=> {
      closer.addEventListener('click', (event) => {
        event.preventDefault()
        Tween24.tween(spnav, .2, Ease24._1_SineInOut).opacity(0).onComplete(()=> {
          spnav.style.display = "none"
        }).play()
      })
    }).play()
  })
}